import { createSlice } from "@reduxjs/toolkit";

// import { mockStats } from "mock/stats";
import { Status } from "@enums/statistic";
import { Direction } from "@enums/direction";
import { loadOrdersStatistic } from "@store/thunks/stats";
import { mapToStatsState } from "@mappers/mapToStatsState";
import { setInitialTimeRange } from "@utils/setInitialTimeRange";

import type { PayloadAction } from "@reduxjs/toolkit";
import type { DateRange, Filters, Sort, Statistic } from "@interfaces/stats";

export type StatsState = {
  isLoading: boolean;
  data: Statistic[];
  filters: Partial<Filters>;
  dateRange: DateRange;
  sort: { direction: Direction; orderBy: keyof Statistic };
};

const initialState: StatsState = {
  data: [],
  isLoading: false,
  filters: {
    [Status.InTransit]: false,
    [Status.Delivered]: false,
    [Status.AtReceiver]: false,
    [Status.ScheduledPU]: false,
  },
  dateRange: setInitialTimeRange(),
  sort: { direction: Direction.Desc, orderBy: "delDate" },
};

export const statsSlice = createSlice({
  name: "STATS",
  initialState,

  reducers: {
    setSort: (state: StatsState, { payload }: PayloadAction<Sort>) => {
      state.sort = payload;
    },

    setFilters: (
      state: StatsState,
      { payload }: PayloadAction<Partial<Filters>>,
    ) => {
      state.filters = payload;
    },

    setRange: (
      state: StatsState,
      { payload }: PayloadAction<DateRange | null>,
    ) => {
      state.dateRange = payload ?? setInitialTimeRange();
    },
  },

  extraReducers: (builder) => {
    builder.addCase(loadOrdersStatistic.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(loadOrdersStatistic.fulfilled, (state, { payload }) => {
      state.data = mapToStatsState(payload!);
      // state.data = mockStats;
      state.isLoading = false;
    });
  },
});

export const { setSort, setFilters, setRange } = statsSlice.actions;

export default statsSlice.reducer;
